import React, { useState } from 'react';
import { useMap } from 'react-leaflet'
import { useGeolocation } from 'react-use';
import { BSSAutocomplete, DefaultLoadingComponent } from '../form';
import {Grid} from '@mui/material'
//import icon from 'leaflet/dist/images/marker-icon.png';
//import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import { FormProvider, useForm } from 'react-hook-form';
import {DefaultSubmitErrorHandler} from './Preventivo'
import BSSButton from '../form/BSSButton'
import useBSSLogger from '../../hooks/useBSSLogger'; 

//import L from 'leaflet';
import BSSForm from '../form/BSSForm';
import __t from '../../lib/traduzioni';
import getapiclient from '../../lib/ajaxhelper';
import { useTheme } from '@emotion/react';
const distFold = "/wp-content/plugins/spedizioniweb2/lib/dist/";
// let DefaultIcon = L.icon({
//     iconUrl: `${distFold}${icon}`,
//     shadowUrl: `${distFold}${iconShadow}`,

// });
//L.Marker.prototype.options.icon = DefaultIcon;
// const customMarkerIcon = new L.DivIcon({
//     className: '',
//     // iconAnchor: [12, 25],
//     // labelAnchor: [-6, 0],
//     // popupAnchor: [0, -15],
//     // iconSize: [25, 41],
//     // html: ReactDomServer.renderToString(<FontAwesomeIcon icon='map-marker-alt' size='3x' color="blue" />)
//     html: ReactDomServer.renderToString(<LocationOn color="blue" />)
// })

const {logger} = useBSSLogger();

const cercaOSM = async (term) => {
    logger.debug("cerco su osm per ", term);

    try{
        const {data} = await getapiclient()
            .get(`https://nominatim.openstreetmap.org/search?q=${term}&limit=10&format=json`) 
        logger.debug("response ricerca osm", data)

        return (data ?? [])
    } catch(err){
        logger.debug("errore ricerca osm", err)
    }
    

}

const RefreshMap = ({center, zoom = 15}) => {
    const map = useMap();
    map.setView(center, zoom);
    return null;
}


const PuntiRitiroConsegna = () => {

    const theme = useTheme();

    const [center, setCenter] = useState(null);

    const onSubmit = (value) => {
        logger.debug("submit ricerca", value.cercaindirizzo)
        setCenter(value.cercaindirizzo)
    }

    const {loading, latitude, longitude} = useGeolocation({enableHighAccuracy: true});
    const methods = useForm();

    if(loading){
        return <DefaultLoadingComponent />
    }

    const centro = center !== null ? [center.lat, center.lon] : [latitude, longitude]

    return (
        <>
            <FormProvider {...methods}>

                <BSSForm
                    onSubmit={methods.handleSubmit(
                        onSubmit,
                        DefaultSubmitErrorHandler,
                    )}
                    methods={methods}
                >

                    <BSSAutocomplete
                            name={`cercaindirizzo`} 
                            label={__t("cercaperindirizzo")}    
                            methods={methods}
                            remoteSearch={{fn: cercaOSM, params: [], debounceTime: 1200}}
                            AutocompleteProps={{
                                getOptionLabel: (option) => `${option.display_name} (${option.lat}, ${option.lon})`,
                                renderOption: (props, option, { selected }) =>(
                                    <li {...props}>
                                        {`${option.display_name} (${option.lat}, ${option.lon})`}
                                    </li>
                                ),
                                isOptionEqualToValue: (option, value) => option.place_id === value.place_id             
                            }}                            
                        />

                    <Grid item xs={12} >
                        <BSSButton
                            methods={methods}
                            type="submit"
                            size="large"
                            style={{fontWeight: 'bolder'}}
                            variant="contained"
                            color="primary"
                            fullWidth
                        >
                            {`${__t('cerca')}`}
                        </BSSButton>
                    </Grid>
                </BSSForm>
            </FormProvider>

            {/* <MapContainer center={centro} zoom={15} style={{ height: "500px" }}>
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                <RefreshMap center={centro} />
                                
                <Marker position={centro} icon={customMarkerIcon}>
                    <Popup>
                        A pretty CSS3 popup. <br /> Easily customizable.
                    </Popup>
                </Marker>
            </MapContainer> */}
        </>
    )
}

export default PuntiRitiroConsegna;